import { render, staticRenderFns } from "./internalResultDetail.vue?vue&type=template&id=bf5b9f66"
import script from "./internalResultDetail.vue?vue&type=script&lang=js"
export * from "./internalResultDetail.vue?vue&type=script&lang=js"
import style0 from "./internalResultDetail.vue?vue&type=style&index=0&id=bf5b9f66&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf5b9f66')) {
      api.createRecord('bf5b9f66', component.options)
    } else {
      api.reload('bf5b9f66', component.options)
    }
    module.hot.accept("./internalResultDetail.vue?vue&type=template&id=bf5b9f66", function () {
      api.rerender('bf5b9f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/temp/internalResultDetail.vue"
export default component.exports